export const SHOE_LOYALTY = [
  'Left Shoe First',
  'Right Shoe First',
  'Alternate Daily',
  'Depends on Season',
] as const
export const SKELETON_STATUS = [
  'Fully Installed',
  'Mostly Installed',
  'Temporary Replacement',
  'Unsure',
] as const
export const ROMAN_EMPERORS = [
  { value: 'Augustus', label: 'Augustus' },
  { value: 'Nero', label: 'Nero' },
  { value: 'Trajan', label: 'Trajan' },
  { value: 'Caligula', label: 'Caligula' },
  { value: 'Other', label: 'Other (Not Supported)', disabled: true },
]
export const IGNORE_METHODS = [
  'Immediately',
  'Professionally',
  'With Mild Concern',
  'During Lunch',
  'After Consulting Legal',
] as const
export const HOLD_MUSIC = [
  'Gregorian Chant',
  'Dial-Up Modem',
  'Aggressive Flute',
  'Corporate Silence',
] as const
export const DINOSAURS = [
  'T-Rex',
  'Triceratops',
  'Ankylosaurus',
  'Emotional Support Raptor',
] as const
export const YEARS = [
  '1997',
  '2025',
  '2048',
  'Time Is A Social Construct',
] as const
export const REFRIGERATOR_VIBES = [
  'Authoritative',
  'Nurturing',
  'Passive Aggressive',
  'Witness Protection',
] as const
export const TURN_SIGNALS = ['Standard', 'Jazz', 'Funk', 'Morse Code'] as const
export const VEHICLES = [
  'Bicycle',
  'Golf Cart',
  'School Bus',
  'Aircraft Carrier',
] as const
export const CAPTCHA_ALIGNMENT = [
  'Pro-CAPTCHA',
  'Anti-CAPTCHA',
  'CAPTCHA Neutral',
  'Prefer Not To Say',
] as const
export const USB_PORTS = [
  'Front Left',
  'Front Right',
  'Rear Upper',
  'Rear Lower',
  'The Secret One',
] as const
export const INTERNAL_MONOLOGUE = [
  'Muted',
  'Conversational',
  'IMAX Theater',
  'Bagpipes',
] as const
export const MEETING_LENGTHS = [
  '6 Seconds',
  '14 Minutes',
  '7 Hours',
  'Eternal',
] as const
export const SPIRIT_ANIMALS = [
  'Compliance Otter',
  'Synergy Goose',
  'Agile Ferret',
  'Enterprise Llama',
] as const
export const MARITIME_LAW = ['Yes', 'No', 'Occasionally'] as const
export const EXPORT_CLASSES = [
  'Public',
  'Proprietary',
  'Agricultural',
  'Classified',
] as const
export const TAX_DEDUCTIBLE = [
  'Yes',
  'No',
  'Ask Your Priest',
  'Pending Review',
] as const
export const PLANETS = [
  'Mercury',
  'Venus',
  'Earth',
  'Mars',
  'Jupiter',
  'Saturn',
  'Uranus',
  'Neptune',
] as const

export const CHECKLIST_ITEMS = [
  'I am reasonably confident I exist.',
  'My skeleton is accounted for.',
  'I have disclosed all relevant goose information.',
  'I understand this form may be reviewed by a committee of retired pigeons.',
  'I waive my right to efficient communication.',
] as const
